import React, { Component } from 'react';
import { showWhenPermission } from '@/shared/components/security';
import AssignmentAnalysisMatrix from '@/modules/hrm/assignmentAnalysis/AssignmentAnalysisMatrix';

class AssignmentAnalysisEmployeeTaskMatrix extends Component {
  render() {
    return <AssignmentAnalysisMatrix matrixType="task"></AssignmentAnalysisMatrix>;
  }
}

export default showWhenPermission(
  'RegistrationOwn', // TODO:
  'read',
)(AssignmentAnalysisEmployeeTaskMatrix);
